import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { getRoleKey, getRoleLabel } from "@/lib/user-display";
import type { User } from "@/types/user";
import type { BadgeProps } from "@/components/ui/badge";

const ROLE_VARIANTS: Record<string, BadgeProps["variant"]> = {
	admin: "important",
	owner: "important",
	manager: "primary",
	lead: "primary",
	member: "default",
	user: "default",
	client: "accent",
	guest: "outline",
	viewer: "outline",
};

interface UserRoleBadgeProps {
	user: User | null | undefined;
	className?: string;
}

/** Renders the user's global role (user type) as a badge. */
export function UserRoleBadge({ user, className }: UserRoleBadgeProps) {
	const label = getRoleLabel(user);
	if (!label) return null;

	const key = getRoleKey(user)?.toLowerCase() ?? "";

	return (
		<Badge
			variant={ROLE_VARIANTS[key] ?? "default"}
			className={cn("text-[10px]! px-2 py-0", className)}
		>
			{label}
		</Badge>
	);
}

export default UserRoleBadge;
